import PropTypes from 'prop-types';
import React from 'react';
import {Col} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import StarRatings from 'react-star-ratings';
import {AttributeDiv} from '../../../common/components/layout/InputCol';
import {CenteredP} from '../../../common/components/StyledComp';

const TicketRating = ({t, receipt}) => {
  return (
    <Col xs={12}>
      <label className="mandatory-label">
        <AttributeDiv className="label-name">{t('popinDetails.rating')}</AttributeDiv>
        {
          receipt.rating !== null ? (
            <StarRatings
              rating={receipt.rating || 0}
              starDimension="20px"
              starSpacing="3px"
              starRatedColor='#C90164'
            />
          ) : <CenteredP>{t('ticketInfo.noNote')}</CenteredP>
        }
      </label>
    </Col>
  );
};

TicketRating.propTypes = {
  t: PropTypes.func.isRequired,
  receipt: PropTypes.shape({
    rating: PropTypes.number,
  }).isRequired,
};

export default withTranslation('ticket')(TicketRating);
